// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"button_buttonWrapper__u4kTy","loader":"button_loader__zVZ1j","l20-1":"button_l20-1__snBUL","l20-2":"button_l20-2__376gq","selfyButton":"button_selfyButton__e3RWj"};